<app-sale-quote-grid
    [permissionKey]="'saleQuotes.list'"
    [filter]="['ThirdId.Id eq ' + this.element.Id]"
    (add)="onAddButtonClicked()"
    [columns]="SaleQuoteColumns"
></app-sale-quote-grid>